import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Flame, ArrowLeft, FileText } from "lucide-react";
import { TERMS_CONTENT as CONTENT } from "./termsContent";

// Pricing/features here must mirror what the codebase actually ships.

export default function Terms() {
    const { lang } = useApp();
    const c = CONTENT[lang] || CONTENT.fr;

    return (
        <div className="min-h-screen bg-[#080B10] text-slate-200" data-testid="terms-page">
            <div className="max-w-3xl mx-auto px-4 sm:px-8 pt-10 pb-24">
                <Link to="/" className="inline-flex items-center gap-2 text-xs font-mono-sf uppercase tracking-widest text-slate-500 hover:text-[#FF4D00] kinetic" data-testid="terms-back-link">
                    <ArrowLeft className="w-3.5 h-3.5" /> {c.back}
                </Link>

                <div className="mt-8 flex items-center gap-3">
                    <span className="flame-gradient w-9 h-9 rounded-md grid place-items-center flame-glow">
                        <Flame className="w-4 h-4 text-black" strokeWidth={3} />
                    </span>
                    <span className="font-display text-xl font-extrabold uppercase">Shorts <span className="flame-text">Factory</span></span>
                </div>

                <div className="mt-10 flex items-center gap-2">
                    <FileText className="w-5 h-5 text-[#FF4D00]" />
                    <div className="overline">Legal · Terms</div>
                </div>
                <h1 className="font-display text-4xl sm:text-5xl font-black uppercase mt-3 leading-tight">{c.title}</h1>
                <p className="mt-2 text-sm text-slate-400">{c.subtitle}</p>
                <p className="mt-3 text-xs font-mono-sf uppercase tracking-widest text-slate-500">{c.updated}</p>

                <div className="mt-12 space-y-10">
                    {c.sections.map((s, i) => (
                        <section key={i} data-testid={`terms-section-${i}`}>
                            <h2 className="font-display text-xl font-black uppercase text-white leading-tight">{s.h}</h2>
                            <p className="mt-3 text-sm leading-relaxed text-slate-300 whitespace-pre-line">{s.body}</p>
                        </section>
                    ))}
                </div>

                <div className="mt-14 flex flex-wrap gap-5 text-xs font-mono-sf text-slate-500">
                    <Link to="/" className="hover:text-[#FF4D00] uppercase tracking-widest kinetic" data-testid="terms-footer-home">{c.back}</Link>
                    <Link to="/privacy" className="hover:text-[#FF4D00] uppercase tracking-widest kinetic" data-testid="terms-footer-privacy">{lang === "fr" ? "Politique de confidentialité" : lang === "es" ? "Política de privacidad" : "Privacy policy"}</Link>
                </div>
            </div>
        </div>
    );
}
